import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Edit, Eye, FilePenLine, MapPin } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateRoute from "./createRoute";

export const QuickActionsSidebar: React.FC<{ data: any }> = ({ data }) => {
  const navigate = useNavigate();
  const [openCreateRoute, setOpenCreateRoute] = useState(false);
  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Quick Actions</CardTitle>
          <p className="text-sm text-gray-600">Manage this read cycle.</p>
        </CardHeader>
        <CardContent className="space-y-3 flex flex-col">
          <Button
            variant="outline"
            className="w-full justify-start p-2"
            tooltip={"Edit System"}
            onClick={() => navigate(`/mx/read-cycle/edit/${data?.id}`)}
          >
            <Edit className="h-4 w-4" />
            Edit Read Cycle
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start p-2"
            tooltip={"Edit Schedule"}
            disabled={data?.status === "UNSCHEDULED"}
            onClick={() => navigate(`/mx/schedule/edit/${data?.scheduleId}`)}
          >
            <FilePenLine className="h-4 w-4" />
            <span className="truncate text-left">Edit Schedule</span>
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start p-2"
            tooltip={"View Schedule"}
            disabled={data?.status === "UNSCHEDULED"}
            onClick={() => navigate(`/mx/schedule/view/view-details/${data?.scheduleId}`)}
          >
            <Eye className="h-4 w-4" />
            <span className="truncate text-left">View Schedule</span>
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start p-2"
            tooltip={"Add Route"}
            onClick={() => setOpenCreateRoute(true)}
          >
            <MapPin className="h-4 w-4" />
            <span className="truncate text-left">Add Route</span>
          </Button>
        </CardContent>
      </Card>
      <CreateRoute
        entityName="Read Cycle"
        openCreateRoute={openCreateRoute}
        setOpenCreateRoute={setOpenCreateRoute}
        meterCycleId={data?.id}
      />
    </div>
  );
};
